// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const NotFound = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     navigate("/");
//   }, [navigate]);

//   return null; // No UI needed since we're redirecting
// };

// export default NotFound;
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000); // Redirect after 5 second

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1 style={styles.heading}>404 - Page Not Found</h1>
        <p style={styles.text}>This page doesn't exist. You’ll be redirected shortly.</p>
        <button style={styles.button} onClick={() => navigate('/')}>
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f8f8f8',
  },
  container: {
    textAlign: 'center',
    padding: '40px',
    border: '1px solid #ccc',
    borderRadius: '12px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  },
  heading: {
    fontSize: '2rem',
    marginBottom: '10px',
    color: '#333',
  },
  text: {
    marginBottom: '20px',
    color: '#555',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1rem',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '6px',
  },
};

export default NotFound;

